module.exports = __webpack_public_path__ + "media/src/components/shared/general/rating_img/fullPinkStar-c34071831b9d7cc2e6a54d7f648e5fc2.png";